<template>
  <div v-if="visible" class="qilin-modal" role="dialog" aria-modal="true" aria-labelledby="qilin-profile-title" @click.self="close">
    <form class="qilin-modal__card" novalidate @submit.prevent="save">
      <button v-if="pet.name && pet.gender" class="qilin-modal__close" type="button" aria-label="ปิด" @click="close">×</button>
      <span class="qilin-modal__eyebrow">คู่หูของคุณ</span>
      <h2 id="qilin-profile-title">{{ pet.name ? 'แก้ไขชื่อคู่หู' : 'ทำความรู้จักกันก่อน' }}</h2>
      <p>เลือกเพศได้ครั้งเดียว ส่วนการตั้งชื่อครั้งแรกฟรี</p>

      <label>ชื่อคู่หู</label>
      <input v-model.trim="name" maxlength="20" required placeholder="เช่น น้องโชคดี">

      <label>เพศ</label>
      <div class="qilin-modal__genders">
        <button type="button" :disabled="Boolean(pet.gender)" :class="{ active: gender === 'male' }" @click="gender = 'male'">♂ คู่หูตัวผู้</button>
        <button type="button" :disabled="Boolean(pet.gender)" :class="{ active: gender === 'female' }" @click="gender = 'female'">♀ คู่หูตัวเมีย</button>
      </div>
      <small v-if="pet.gender">เพศถูกบันทึกแล้วและไม่สามารถเปลี่ยนได้</small>
      <div v-if="isRename" class="qilin-modal__cost">การเปลี่ยนชื่อครั้งนี้ใช้ 5 เหรียญ</div>
      <div v-if="displayError" class="qilin-modal__error" role="alert">{{ displayError }}</div>
      <button class="qilin-modal__save" type="submit" :disabled="saving">
        {{ saving ? 'กำลังบันทึก...' : isRename ? 'ยืนยันเปลี่ยนชื่อ' : 'เริ่มเลี้ยงคู่หู' }}
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'QilinProfileModal',
  props: {
    visible: { type: Boolean, default: false },
    pet: { type: Object, required: true },
    saving: { type: Boolean, default: false },
    error: { type: String, default: '' }
  },
  data () { return { name: '', gender: '', validationError: '' } },
  computed: {
    isRename () { return Boolean(this.pet.name && this.name && this.pet.name !== this.name) },
    displayError () { return this.validationError || this.error }
  },
  watch: {
    visible: {
      immediate: true,
      handler (visible) {
        if (visible) {
          this.name = this.pet.name || ''
          this.gender = this.pet.gender || ''
          this.validationError = ''
        }
      }
    },
    name () { this.validationError = '' },
    gender () { this.validationError = '' }
  },
  methods: {
    close () { if (this.pet.name && this.pet.gender && !this.saving) this.$emit('close') },
    save () {
      if (!this.name) {
        this.validationError = 'กรุณาตั้งชื่อให้น้องก่อน'
        return
      }
      if (!this.gender) {
        this.validationError = 'กรุณาเลือกเพศก่อนเริ่มเลี้ยง'
        return
      }
      this.validationError = ''
      this.$emit('save', { name: this.name, gender: this.gender })
    }
  }
}
</script>

<style scoped>
.qilin-modal { position: fixed; z-index: 2400; inset: 0; display: grid; place-items: center; padding: 18px; background: rgba(5, 0, 12, .86); backdrop-filter: blur(9px); font-family: 'Kanit', sans-serif; }
.qilin-modal__card { position: relative; width: min(440px, 100%); padding: 28px; overflow: hidden; border: 1px solid #9d36d6; border-radius: 24px; background: radial-gradient(circle at 85% 0, rgba(151, 35, 207, .24), transparent 38%), linear-gradient(155deg, #26083a, #0c0215 74%); box-shadow: 0 0 0 1px rgba(255, 213, 89, .14), 0 0 34px rgba(158, 46, 220, .28), 0 28px 80px rgba(0, 0, 0, .58); color: #fff; }
.qilin-modal__card::before { content: ''; position: absolute; top: 0; left: 12%; width: 76%; height: 1px; background: linear-gradient(90deg, transparent, #ffd766, transparent); box-shadow: 0 0 12px #f3b93b; }
.qilin-modal__close { position: absolute; top: 13px; right: 13px; width: 34px; height: 34px; border: 1px solid rgba(187, 72, 241, .5); border-radius: 50%; background: rgba(61, 15, 86, .85); color: #fff; font-size: 24px; }
.qilin-modal__eyebrow { color: #ffd766; font-size: 12px; font-weight: 900; letter-spacing: .08em; }
h2 { margin: 5px 0 4px; font-size: 25px; }
p { margin: 0 0 19px; color: #c9b4d3; font-size: 13px; }
label { display: block; margin: 13px 0 7px; font-size: 13px; font-weight: 800; }
input { width: 100%; height: 48px; padding: 0 13px; border: 1px solid rgba(173, 68, 224, .48); border-radius: 13px; outline: none; background: rgba(7, 0, 12, .7); color: #fff; font-family: inherit; }
input::placeholder { color: #8f789b; }
input:focus { border-color: #d96cff; box-shadow: 0 0 0 3px rgba(183, 63, 235, .16), inset 0 0 14px rgba(132, 26, 176, .14); }
.qilin-modal__genders { display: grid; grid-template-columns: 1fr 1fr; gap: 9px; }
.qilin-modal__genders button { min-height: 48px; border: 1px solid rgba(173, 68, 224, .42); border-radius: 13px; background: linear-gradient(145deg, rgba(74, 20, 104, .52), rgba(13, 3, 23, .78)); color: #d5c2de; font-family: inherit; font-weight: 800; }
.qilin-modal__genders button:hover:not(:disabled), .qilin-modal__genders button:focus-visible { border-color: #d96cff; color: #fff; }
.qilin-modal__genders button.active { border-color: #ffd65a; background: linear-gradient(145deg, rgba(116, 67, 12, .6), rgba(49, 15, 55, .8)); box-shadow: inset 0 0 15px rgba(255, 203, 74, .12), 0 0 10px rgba(226, 171, 46, .16); color: #ffe689; }
.qilin-modal__genders button:disabled:not(.active) { opacity: .35; }
small { display: block; margin-top: 7px; color: rgba(255, 255, 255, .45); font-size: 11px; }
.qilin-modal__cost { margin-top: 15px; padding: 10px; border: 1px solid rgba(255, 210, 83, .2); border-radius: 10px; background: rgba(251, 200, 68, .08); color: #ffe079; font-size: 12px; text-align: center; }
.qilin-modal__error { margin-top: 14px; padding: 10px 12px; border: 1px solid rgba(255, 115, 115, .28); border-radius: 10px; background: rgba(255, 83, 83, .1); color: #ffb6b6; font-size: 12px; text-align: center; }
.qilin-modal__save { width: 100%; min-height: 49px; margin-top: 18px; border: 1px solid #fff0ae; border-radius: 14px; background: linear-gradient(135deg, #ffd85d, #e49b16); box-shadow: inset 0 1px 0 rgba(255,255,255,.45), 0 0 18px rgba(244, 185, 43, .28); color: #241123; font-family: inherit; font-weight: 900; }
.qilin-modal__save:hover:not(:disabled), .qilin-modal__save:focus-visible { filter: brightness(1.08); box-shadow: inset 0 1px 0 rgba(255,255,255,.55), 0 0 24px rgba(244, 185, 43, .45); }
.qilin-modal__save:disabled { opacity: .48; }
</style>
